<div class="form-container">
  <div class="form-content">
    <div class="info">
      <div class="title">
        <h3>{{"company.employees.add_employee.title" | translate}}</h3>
      </div>
      <div class="subtitle">
        <p>{{"company.employees.add_employee.subtitle" | translate}}</p>
        <p>{{"company.employees.add_employee.subtitle2" | translate}}</p>
      </div>
    </div>
    <div class="form">
      <div class="form-title">
        <h3>{{"company.employees.add_employee.form.title" | translate}}</h3>
      </div>
      <form (ngSubmit)="onSubmit()" [formGroup]="registerForm">
        <div class="inputs">
          <div class="input name">
            <input
              type="text"
              formControlName="name"
              class="form-control"
              [ngClass]="{ 'is-invalid': form.name.errors }"
              placeholder="{{'company.employees.add_employee.form.name' | translate}}"
            />
            <div *ngIf="form.name.errors" class="invalid-feedback">
              <span *ngIf="form.name.errors.required">
                {{"company.employees.add_employee.form.validators.name" | translate}}
              </span>
            </div>
          </div>

          <div class="input email">
            <input
              type="email"
              formControlName="email"
              class="form-control"
              [ngClass]="{ 'is-invalid': form.email.errors }"
              placeholder="tuemail@email.com"
            />
            <div *ngIf="form.email.errors" class="invalid-feedback">
              <span *ngIf="form.email.errors.required">
                {{"company.employees.add_employee.form.validators.email" | translate}}
              </span>
              <span *ngIf="form.email.errors.email">
                {{"company.employees.add_employee.form.validators.email2" | translate}}
              </span>
            </div>
          </div>


          <div class="input id">
            <input type="number" formControlName="employee_id" class="form-control" placeholder="24"/>
          </div>


          <div class="input cp">
            <input
              type="string"
              formControlName="cp"
              class="form-control"
              [ngClass]="{ 'is-invalid': form.cp.errors }"
              [placeholder]="'company.employees.add_employee.form.cp' | translate"
            />
            <div *ngIf="form.cp.errors" class="invalid-feedback">
              <span *ngIf="form.cp.errors.required">
                {{"company.employees.add_employee.form.validators.cp" | translate}}
              </span>
              <span *ngIf="form.cp.errors.pattern">
                {{"company.employees.add_employee.form.validators.cp2" | translate}}
              </span>
            </div>
          </div>

          <div class="input language">
            <select
              name="language"
              id="language"
              formControlName="language"
              class="lang form-control"
              [ngClass]="{ 'is-invalid': form.language.errors }">
              <option value="" selected>{{"company.employees.add_employee.form.language" | translate}}</option>
              <option value="es_ES">EspaÃ±ol</option>
              <option value="en_EN">English</option>
            </select>
            <div *ngIf="form.language.errors" class="invalid-feedback">
              <span *ngIf="form.language.errors.required">
                {{"company.employees.add_employee.form.validators.language" | translate}}
              </span>
            </div>
          </div>

          <div class="input cowings">
            <div class="cowings-mes">
              <label for="total_cowings" >{{"company.employees.add_employee.form.cowings" | translate}}</label><br>
              <span>Cowings</span>
            </div>
            <input
              type="number"
              placeholder="200"
              formControlName="total_cowings"
              class="form-control"
              [ngClass]="{ 'is-invalid': form.total_cowings.errors }"
            />
            <div *ngIf="form.total_cowings.errors" class="invalid-feedback">
              <span *ngIf="form.total_cowings.errors.required">
                {{"company.employees.add_employee.form.validators.cowings" | translate}}
              </span>
            </div>
          </div>

        </div>
        <div class="buttons">
          <cowing-button
            [label]="'general.cancel' | translate"
            [type]="EButtonType.RoundedSecondary"
            (click)="onReset()"
          >
          </cowing-button>
          <cowing-button
            [label]="'company.steps.confirm' | translate"
            [type]="EButtonType.Rounded"
            [disabled]="registerForm.invalid"
            [isSubmit]="true"
          >
          </cowing-button>
        </div>
      </form>
    </div>
  </div>
</div>
